import Lottie from "lottie-react";
import ClickAnimation from "../../assets/json/ClickAnimation.json";
import LeftSectionBlock from "../../components/LeftSectionBlock";
import RightSectionBlock from "../../components/RightSectionBlock";

const MainContent = () => {
  return (
    <>
      <div className="gray-main-container-blk ph-holiday-container">
        <div className="flex-box-blk">
          <div className="hover-holiday-blk">
            <Lottie
              id="cursorPointer"
              className="click-animation-blk-dna"
              animationData={ClickAnimation}
              style={{zIndex: "9999"}}
              onMouseEnter={() => {
                let cursorPointer = document.getElementById("cursorPointer");
                if (cursorPointer) {
                  cursorPointer.style.display = "none";
                }
              }}
            />
            <div className="header-title-month">JANUARY</div>
            <div className="day-section">
              <h2>01</h2>
            </div>
            <p>New Year's Day</p>
            <div className="tooltip-blk">
              A public holiday marking the start of the Gregorian calendar year,
              celebrated with family reunions, festive meals, and traditional
              practices like coin-tossing for luck.
            </div>
          </div>
          <div
            className="hover-holiday-blk"
            onMouseEnter={() => {
              let cursorPointer = document.getElementById("cursorPointer");
              if (cursorPointer) {
                cursorPointer.style.display = "none";
              }
            }}>
            <div className="header-title-month">FEBUARY</div>
            <div className="day-section">
              <h2>01</h2>
            </div>
            <p>Lunar New Year</p>
            <div className="tooltip-blk">
              Also known as Chinese New Year, this vibrant celebration is
              observed by Filipino-Chinese communities and increasingly embraced
              nationwide, featuring red decorations, lion dances, and family
              feasts
            </div>
          </div>
          <div>
            <div className="header-title-month">MARCH</div>
            <div className="flex-box-blk">
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>28</h2>
                </div>
                <p>Maundy Thursday</p>
                <div className="tooltip-blk">
                  A public holiday commemorating Jesus Christ's last supper,
                  often observed with religious services and family gatherings
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>29</h2>
                </div>
                <p>Good Friday</p>
                <div className="tooltip-blk">
                  A national day of reflection and rest in observance of Jesus
                  Christ's crucifixion and death.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>30</h2>
                </div>
                <p>Holy Saturday</p>
                <div className="tooltip-blk">
                  The final day of Holy Week, typically a time for preparation
                  before Easter Sunday celebrations.
                </div>
              </div>
            </div>
          </div>
          <div
            className="hover-holiday-blk"
            onMouseEnter={() => {
              let cursorPointer = document.getElementById("cursorPointer");
              if (cursorPointer) {
                cursorPointer.style.display = "none";
              }
            }}>
            <div className="header-title-month">APRIL</div>
            <div className="day-section">
              <h2>09</h2>
            </div>
            <p>Day of Valor</p>
            <div className="tooltip-blk-left">
              Honors the bravery of Filipino and American soldiers in World War
              II, particularly remembering the Fall of Bataan.
            </div>
          </div>
        </div>

        <div className="flex-box-blk">
          <div
            className="hover-holiday-blk"
            onMouseEnter={() => {
              let cursorPointer = document.getElementById("cursorPointer");
              if (cursorPointer) {
                cursorPointer.style.display = "none";
              }
            }}>
            <div className="header-title-month">MAY</div>
            <div className="day-section">
              <h2>01</h2>
            </div>
            <p>Labor Day</p>
            <div className="tooltip-blk">
              A celebration of workers' rights and contributions to the nation,
              often marked by rallies and government announcements.
            </div>
          </div>
          <div
            className="hover-holiday-blk"
            onMouseEnter={() => {
              let cursorPointer = document.getElementById("cursorPointer");
              if (cursorPointer) {
                cursorPointer.style.display = "none";
              }
            }}>
            <div className="header-title-month">JUNE</div>
            <div className="day-section">
              <h2>12</h2>
            </div>
            <p>Indepedence Day</p>
            <div className="tooltip-blk">
              Commemorates the Philippines' 1898 declaration of independence
              from Spain, celebrated with parades and flag-raising ceremonies.
            </div>
          </div>
          <div>
            <div className="header-title-month">AUGUST</div>
            <div className="flex-box-blk">
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>21</h2>
                </div>
                <p>
                  Ninoy <br />
                  Aquino Day
                </p>
                <div className="tooltip-blk">
                  Remembers the 1983 assassination of Senator Benigno Aquino
                  Jr., a pivotal event that sparked the People Power Revolution.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>26</h2>
                </div>
                <p>
                  National <br />
                  Heroes' Day
                </p>
                <div className="tooltip-blk">
                  Honors all Philippine national heroes, known and unknown, who
                  fought for the country's freedom and democracy.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="header-title-month">NOVEMBER</div>
            <div className="flex-box-blk">
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>01</h2>
                </div>
                <p>All Saints' Day</p>
                <div className="tooltip-blk">
                  A public holiday where many Filipinos visit cemeteries to
                  honor deceased family members, often bringing flowers and
                  candles.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>02</h2>
                </div>
                <p>All Souls' Day</p>
                <div className="tooltip-blk-left">
                  A public holiday continuing the remembrance of the departed,
                  offering prayers, and holding family gatherings.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>30</h2>
                </div>
                <p>Bonafacio Day</p>
                <div className="tooltip-blk-left">
                  Celebrates the birth of Andres Bonifacio, a key figure in
                  Philippine independence, celebrated with parades and
                  historical reenactments.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="header-title-month">DECEMBER</div>
            <div className="flex-box-blk">
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>08</h2>
                </div>
                <p>
                  Feast of the <br />
                  Immaculate Conception
                </p>
                <div className="tooltip-blk">
                  A national holiday celebrating a significant Catholic belief,
                  marked by church services and family gatherings.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>24</h2>
                </div>
                <p>Christmas Eve</p>
                <div className="tooltip-blk">
                  The night before Christmas, traditionally celebrated with
                  Noche Buena, a midnight feast bringing families together.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>25</h2>
                </div>
                <p>Christmas Day</p>
                <div className="tooltip-blk">
                  A major holiday in the Philippines, celebrated with an
                  extended season of festivities, gift-giving, and family
                  reunions.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>30</h2>
                </div>
                <p>Rizal Day</p>
                <div className="tooltip-blk">
                  Honors Dr. Jose Rizal, the Philippines' national hero, with
                  ceremonies at his monument in Manila and nationwide tributes
                  to his life and works.
                </div>
              </div>
              <div className="hover-holiday-blk">
                <div
                  className="day-section"
                  onMouseEnter={() => {
                    let cursorPointer =
                      document.getElementById("cursorPointer");
                    if (cursorPointer) {
                      cursorPointer.style.display = "none";
                    }
                  }}>
                  <h2>31</h2>
                </div>
                <p>Last Day of the Year</p>
                <div className="tooltip-blk-left">
                  A festive celebration marking the year's end, featuring family
                  gatherings, the traditional Media Noche feast, and fireworks
                  displays across the country.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const PhilippineHolidayPage = () => {
  return (
    <div className="main-container-blk">
      <div className="main-section-blk">
        <LeftSectionBlock />
        <RightSectionBlock
          title="PHILIPPINE HOLIDAYS 2025"
          stringBlurb="Plan the year with the official list of Philippine Regular Holidays, observed nationwide to mark important dates. Note that this list includes only regular holidays and excludes special non-working days or other government-declared holidays."
          previousBtn="/information-security"
          nextBtn=""
          disableNextBtn={true}
          mainContent={<MainContent />}
        />
      </div>
    </div>
  );
};

export default PhilippineHolidayPage;
